import { instance } from "libs/api";

import { ApiRoutesRecommendation } from "../../constants";
import {
  CategoryEnrichmentProfile,
  SetCategoryProfilePayload
} from "../../recommendation.types";

export const requestSetEnrichmentProfile = async (
  payload: SetCategoryProfilePayload
): Promise<CategoryEnrichmentProfile> => {
  return await instance.post(
    ApiRoutesRecommendation.EnrichmentProfiles,
    payload
  );
};
